import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreClass as apiFn } from "../../api/apiClasses";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreClass() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: restoreClass, isPending: isRestore } = useMutation({
        mutationFn: (id) => apiFn(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["classes"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { restoreClass, isRestore };
}
